import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Alert, Card } from "reactstrap";
import PromoItem from "../../components/promoItem";
import UserWelcome from "../../components/userWelcome";
import UserStatementsGraph from "../../components/userStatementsGraph";
import SubuserStatementsGraph from "../../components/subuserStatementsGraph";
import { StateContext } from "../../utils/context";
import UserZohoASAPWidgetDemo from "../../components/userZohoASAPWidgetDemo";
import UserZohoASAPWidgetStandardSubscription from "../../components/userZohoASAPWidgetStandardSubscription";
import UserZohoASAPWidgetPremiumSubscription from "../../components/userZohoASAPWidgetPremiumSubscription";
import UserZohoASAPWidgetGoldSubscription from "../../components/userZohoASAPWidgetGoldSubscription";
import SubUserZohoASAPWidget from "../../components/subuserZohoASAPWidget";
import SubscriptionTiersNew from "../../components/subscriptionTiersNew";
import PromoBanner from "../../components/promoBanner";
import { useTranslation, Trans } from "react-i18next";

const Dashboard = () => {
  const {currentUser} = useContext(StateContext);
  const [promoFeedbackCount, setPromoFeedbackCount] = useState(0);
  const [promoDownloadCount, setPromoDownloadCount] = useState(0);
  const [showSubmitInfoMsg, setShowSubmitInfoMsg] = useState(false);
  const [showSubscriptionTiers, setShowSubscriptionTiers] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    if (currentUser) {
      // setPromoFeedbackCount(currentUser.promo_feedback_count);
      // setPromoDownloadCount(currentUser.promo_download_count);
      if (currentUser && !currentUser.is_sub_user && currentUser.hasOwnProperty('identity_checked') && !currentUser.identity_checked && !currentUser.is_blacklisted) {
        setShowSubmitInfoMsg(true);
      } else {
        setShowSubmitInfoMsg(false);
      }

      if(currentUser && currentUser.hasOwnProperty('has_subscription') && !currentUser.has_subscription) {
        setShowSubscriptionTiers(true);
      } else {
        setShowSubscriptionTiers(false);
      }
    }
  }, [currentUser]);

  return (
    <>
      <Row>
        <Col>
          <UserWelcome />
        </Col>
      </Row>

      {
        currentUser && currentUser.is_blacklisted &&
        <>
          <Alert color="danger">
            {t("dashboard.view.message.accountBlacklisted")}
          </Alert>
        </>
      }

      {
        (currentUser.has_subscription && currentUser.subscription_active) &&
        <>
        {
          showSubmitInfoMsg &&
          <Row>
            <Col>
              <Alert color="info">
                <Trans i18nKey="dashboard.view.message.completeInformation">
                  You have not submitted your information yet, please 
                  <a href="/complete-information">Complete Your Information</a>
                  to proceed further!
                </Trans>
              </Alert>
            </Col>
          </Row>
        }

        {/* <Row>
          <Col>
            {
              (currentUser && currentUser.is_sub_user) && 
              <>
                <SubuserStatementsGraph />
              </>
            }
            {
              (currentUser && !currentUser.is_sub_user) && 
              <>
                <UserStatementsGraph />
              </>
            }
          </Col>
        </Row>

        <Row>
          <PromoItem
            itemIcon="ti-pie-chart"
            itemHeading={t("dashboard.view.label.promoDownloadCount")}
            itemSubHeading={t("dashboard.view.label.totalDownloads")}
            itemCount={promoDownloadCount}
            cardBg="#707cd2"
          />
          <PromoItem
            id="2"
            itemIcon="icon-cloud-download"
            itemHeading={t("dashboard.view.label.promoFeedbackCount")}
            itemSubHeading={t("dashboard.view.label.totalFeedbacks")}
            itemCount={promoFeedbackCount}
            cardBg="#ff5050"
          />
        </Row> */}
        </>
      }

      {
        (!currentUser.has_subscription) &&
        <>
          {currentUser && currentUser.promo_code && (
            <PromoBanner currentUser={currentUser} promoCode={currentUser.promo_code} />
          )}
          {
            showSubscriptionTiers &&
            <>
              <Alert color="danger">
                {t("dashboard.view.message.notSubscribed")}
              </Alert>
              <Card>
                  <SubscriptionTiersNew />
              </Card>
            </>
          }
        </>
      }

      <Row>
        <Col>
          {
            (currentUser && currentUser.is_sub_user) && 
            <>
              <SubUserZohoASAPWidget />
            </>
          }
          {
            (currentUser && !currentUser.is_sub_user && currentUser.subscription_tier_name === "Demo") && 
            <>
              <UserZohoASAPWidgetDemo />
            </>
          }
          {
            (currentUser && !currentUser.is_sub_user && currentUser.subscription_tier_name === "Standard") && 
            <>
              <UserZohoASAPWidgetStandardSubscription />
            </>
          }
          {
            (currentUser && !currentUser.is_sub_user && currentUser.subscription_tier_name === "Premium") && 
            <>
              <UserZohoASAPWidgetPremiumSubscription />
            </>
          }
          {
            (currentUser && !currentUser.is_sub_user && (currentUser.subscription_tier_name === "Gold" || currentUser.subscription_tier_name === "Diamond")) && 
            <>
              <UserZohoASAPWidgetGoldSubscription />
            </>
          }
        </Col>
      </Row>
    </>
  );
};

export default Dashboard;
